import { Component } from "vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";
import { AnalysisConfigHelpContentType } from "../models/AnalysisConfigHelpContentType";


export class AnalysisConfigHelpContentFactory extends HelpContentFactory<AnalysisConfigHelpContentType> {

    public cdnContentPath: string = "analysis-configs";

    public async tryGetStaticHelpContentByType(type: AnalysisConfigHelpContentType | string): Promise<Component | null> {
        switch (type) {
            default:
                return null;
        }
    }

}